export default __webpack_public_path__ + "static/media/weave-image.04dfc8be.png";